import { useTranslate } from "@tolgee/react";
import React, { useEffect, useState } from "react";
import { LINKEDIN, META, URL_PARAM_PLATFORM } from "../../platforms/constants";
import {
  getFacebookPages,
  getGMBLocations,
  getInstagramAccounts,
  getLinkedinBusinessPages,
  getLinkedinPersonalAccounts,
  getTwitterAccounts,
  getYoutubeChannels,
} from "../../platforms/facebook_/utils/api";
import {
  GOOGLE,
  PLATFORM_LIST,
  PLATFORM_LIST_SUPPORTED_IN_COCKPIT,
  SELECTED_PLATFORM_COLOR_CODE,
  TIKTOK_PERSONAL_ACCOUNT,
  TWITTER,
  UPLOAD_TO_PLATFORM_STATUS_FAILED,
  UPLOAD_TO_PLATFORM_STATUS_SUCCESS,
} from "../../../config/constants";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { PATH_PAGE } from "../../../routes/paths";
import SocialMediaProfileTable from "../../platforms/accounts/connected_social_media_accounts/connected_profiles_overview/table";
import { Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import axios from "axios";
import DataTable from "react-data-table-component";
import { PLATFORM_STATIC_ICONS } from "../../../config/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faEye,
  faLink,
  faSpinner,
  faTimes,
} from "@fortawesome/pro-duotone-svg-icons";

const PostPublicationLog = () => {
  const { postuuid } = useParams<{ postuuid: string }>();

  const [dataLoaded, setDataLoaded] = useState(false);
  const [postPublicationLog, setPostPublicationLog] = useState([]);

  const { t } = useTranslate();

  const loadData = () => {
    if (postuuid === undefined) {
      return;
    }
    if (dataLoaded) {
      return;
    }
    axios
      .get("/api/v2/posts/postpublicationlog/", {
        params: {
          multiplatform_social_media_post__uuid: postuuid,
        },
      })
      .then((response) => {
        setPostPublicationLog(response.data.results[0].data_as_json);
        setDataLoaded(true);
      });
  };

  const getSuccessIcon = (row, platform) => {
    if (row.data[platform] === undefined) {
      return (
        <OverlayTrigger
          overlay={
            <Tooltip>{t("t.PostPublicationLog.publicationNotCreated")}</Tooltip>
          }
        >
          <div>-</div>
        </OverlayTrigger>
      );
    }
    if (row.data[platform].status === UPLOAD_TO_PLATFORM_STATUS_SUCCESS) {
      return (
        <OverlayTrigger
          overlay={
            <Tooltip>{t("t.PostPublicationLog.publicationSuccess")}</Tooltip>
          }
        >
          <div>
            <i className="fa-solid fa-check text-success"></i>
          </div>
        </OverlayTrigger>
      );
    }
    if (row.data[platform].status === UPLOAD_TO_PLATFORM_STATUS_FAILED) {
      return (
        <OverlayTrigger
          overlay={
            <Tooltip>{t("t.PostPublicationLog.publicationError")}</Tooltip>
          }
        >
          <div>
            <i className="fa-solid fa-times text-danger"></i>
          </div>
        </OverlayTrigger>
      );
    }
    return (
      <OverlayTrigger
        overlay={
          <Tooltip>{t("t.PostPublicationLog.publicationProcessing")}</Tooltip>
        }
      >
        <div>
          <i className="fa-solid fa-spinner"></i>
        </div>
      </OverlayTrigger>
    );
  };

  const columns = [
    {
      name: "",
      cell: (row) => {
        return (
          <div className={"w-100 py-3"}>
            <h4 className={"mb-2"}>{row.location_name}</h4>
            <div className={"w-100"}>
              <table className={"w-100 table"}>
                <thead>
                  <tr>
                    {PLATFORM_LIST_SUPPORTED_IN_COCKPIT.map((platform) => {
                      return (
                        <td className={"px-1"}>
                          <div
                            className={"d-flex justify-content-center flex-row"}
                          >
                            <img
                              className={"h-20px"}
                              src={PLATFORM_STATIC_ICONS[platform]}
                            />
                          </div>
                        </td>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    {PLATFORM_LIST_SUPPORTED_IN_COCKPIT.map((platform) => {
                      return (
                        <td className={"px-1 text-center"}>
                          {getSuccessIcon(row, platform)}
                        </td>
                      );
                    })}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        );
      },
    },
  ];

  const init = () => {
    loadData();
  };

  useEffect(() => {
    init();
  });

  return (
    <div className={"container"}>
      <div className={"container"}>
        {
          <div className="card card-flush h-md-100">
            <div className="card-header pt-7">
              <h3 className="card-title align-items-start flex-column">
                <span className="card-label fw-bold text-gray-800">
                  {t("PostPublicationLog.Title")}
                </span>
              </h3>
            </div>

            <div className="card-body pt-6">
              {dataLoaded ? (
                <DataTable
                  columns={columns}
                  data={postPublicationLog}
                  pagination
                  paginationComponentOptions={{
                    rangeSeparatorText: t("table.of"),
                    rowsPerPageText: t("table.entries_per_page"),
                  }}
                ></DataTable>
              ) : (
                <div className="d-flex justify-content-center align-items-center">
                  <Spinner animation="border" variant="primary" />
                </div>
              )}
            </div>
          </div>
        }
      </div>
    </div>
  );
};

export default PostPublicationLog;
